import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-equipment-info',
  templateUrl: './equipment-info.component.html',
  styleUrls: ['./equipment-info.component.sass']
})
export class EquipmentInfoComponent implements OnInit {
  @Input() dateWarranty;
  @Input() mobile_image;
  @Input() equipment_name;
  @Input() techField;
  @Input() val_ins_equ;
  @Input() instal_equ;
  @Input() itemBrandField;
  @Input() index;
  @Input() typeAccount;
  public eSNField = [];
  public info = [];
  public sIMField = [];
  public showimgDef: boolean = true;
  constructor() { }

  ngOnInit() {
    this.info = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo;
    this.readImeiandSim();
    this.loadImageDevice(this.mobile_image);
  }
  readImeiandSim() {
    this.eSNField = [];
    this.sIMField = [];
    if (this.info.length != 0) {
      let contadorIMEI = 0;
      let contadorSIM = 0;
      for (let i = 0; i < this.info.length; i++) {
        contadorIMEI = 0;
        contadorSIM = 0;
        for (let j = 0; j < this.info[i].servEquipmentSerialsField.servEquipmentSerialField.length; j++) {
          if (this.info[i].servEquipmentSerialsField.servEquipmentSerialField[j].itemIdField == this.info[i].equipmentInfoField.itemIdField) {
            this.eSNField[i] = this.info[i].servEquipmentSerialsField.servEquipmentSerialField[j].eSNField
            contadorIMEI++;
          }
          if (this.info[i].servEquipmentSerialsField.servEquipmentSerialField[j].equipmentTypeField == 'S') {
            this.sIMField[i] = this.info[i].servEquipmentSerialsField.servEquipmentSerialField[j].eSNField;
            contadorSIM++;
          }
        }
        if (contadorIMEI == 0) {
          this.eSNField[i] = "N/A";
        }
        if (contadorSIM == 0) {
          this.sIMField[i] = "N/A";
        }
      }
    }
  }
  loadImageDevice(card) {
    card = this.mobile_image;
    switch (card) {
      case 'https://miclaro.clarotodo.com/ImageHandler/OracleImageHandler.ashx?DEVICE_ID=30219H':
        this.showimgDef = false;
        break;
      case 'https://storeorders.claropr.com/Portals/Claro/DataFiles/Products/':
        this.showimgDef = false;
        break;
      case null:
        this.showimgDef = false;
        break;
    }
  }
}
